/* Rorilio · PDP Edredón EasySleep® : galería, packs (color + tamaño por edredón, precio recalculado), botón, guía de tamaños, barra fija, carrusel, reseñas.
   Sin script de carrito propio : agrega las variantes reales elegidas a /cart/add.js ; el motor rorilio-offers.js pone códigos y regalos. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $all = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents, fmt) {
    var n = Math.round(cents) / 100, whole = Math.round(n) === n;
    function grp(x, d) { var p = x.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return p.join('.'); }
    return (fmt || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return grp(n, 0);
      if (k === 'amount_with_comma_separator') return grp(n, whole ? 0 : 2).replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
      return grp(n, whole ? 0 : 2);
    });
  }

  function initMain(root) {
    var V = JSON.parse($('[data-es-variants]', root).textContent);
    var C = JSON.parse($('[data-es-cfg]', root).textContent);
    var sw = {};
    String(C.swatches || '').split(/<br\s*\/?>/).forEach(function (l) { var i = l.lastIndexOf(':'); if (i > 0) sw[l.slice(0, i).trim()] = l.slice(i + 1).trim(); });
    var find = function (c, s) { for (var i = 0; i < V.length; i++) if (V[i].c === c && V[i].s === s) return V[i]; return null; };
    var byId = function (id) { for (var i = 0; i < V.length; i++) if (String(V[i].id) === String(id)) return V[i]; return null; };

    /* galería */
    var gal = $('[data-es-gal]', root), slides = $('.es-gal__slides', gal), thumbs = $all('.es-gal__thumb', gal), tw = $('.es-gal__thumbs', gal);
    function go(i) { if (!slides.children[i]) return; slides.scrollTo({ left: slides.children[i].offsetLeft, behavior: 'smooth' }); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    slides.addEventListener('scroll', function () {
      var i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      var t = thumbs[i]; if (t) tw.scrollTo({ left: t.offsetLeft - tw.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    }, { passive: true });
    $('[data-es-tprev]', gal).addEventListener('click', function () { var i = thumbs.findIndex(function (t) { return t.classList.contains('is-on'); }); go(Math.max(0, i - 1)); });
    $('[data-es-tnext]', gal).addEventListener('click', function () { var i = thumbs.findIndex(function (t) { return t.classList.contains('is-on'); }); go(Math.min(thumbs.length - 1, i + 1)); });
    function showMediaOf(v) {
      if (!v || !v.img) return;
      var key = v.img.split('?')[0].split('/').pop().replace(/_\d+x\d*|\.\w+$/g, '');
      for (var i = 0; i < slides.children.length; i++) { var im = slides.children[i].querySelector('img'); if (im && im.src.indexOf(key) > -1) { go(i); return; } }
    }

    /* packs */
    var packs = $all('[data-pack]', root);
    function rowsOf(p) { return $all('[data-row]', p).map(function (r) { return find($('[data-color]', r).value, $('[data-size]', r).value); }); }
    function sync(p) {
      var vs = rowsOf(p), disc = Number(p.getAttribute('data-disc')) || 0, now = 0, was = 0;
      $all('[data-row]', p).forEach(function (r, i) {
        var v = vs[i], c = $('[data-color]', r).value, dot = $('[data-dot]', r);
        if (dot) dot.style.background = sw[c] || '#ccc';
        if (v && v.img) $('[data-row-img]', r).src = v.img;
      });
      vs.forEach(function (v) { if (v) { now += v.p - disc; was += v.w; } });
      $('[data-now]', p).textContent = money(now, C.money);
      $('[data-was]', p).textContent = money(was, C.money);
      $('[data-was]', p).hidden = was <= now;
      if (p.classList.contains('is-on')) stickySync(p, now, was);
    }
    function selected() { return packs.filter(function (p) { return p.classList.contains('is-on'); })[0] || packs[0]; }
    function pick(p) {
      packs.forEach(function (x) { var on = x === p; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      sync(p);
    }
    packs.forEach(function (p) {
      p.addEventListener('click', function (e) { if (e.target.closest('select, label')) return; if (!p.classList.contains('is-on')) pick(p); });
      p.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === p) { e.preventDefault(); pick(p); } });
      $all('select', p).forEach(function (s) {
        s.addEventListener('change', function () {
          var r = s.closest('[data-row]');
          sync(p);
          if (s.hasAttribute('data-color') && r) showMediaOf(find($('[data-color]', r).value, $('[data-size]', r).value));
          if (r && r === $('[data-row]', p)) { var v = rowsOf(p)[0]; if (v && sv) sv.value = String(v.id); }
        });
      });
    });

    /* botón */
    var atc = $('[data-es-atc]', root), err = $('[data-err]', root);
    function add() {
      var p = selected(), vs = rowsOf(p);
      if (vs.some(function (v) { return !v; })) { err.textContent = C.err; err.hidden = false; return; }
      var q = {}, order = [];
      vs.forEach(function (v) { if (!q[v.id]) { q[v.id] = 0; order.push(v.id); } q[v.id]++; });
      var items = order.map(function (id) { return { id: id, quantity: q[id] }; });
      err.hidden = true; atc.setAttribute('aria-busy', 'true');
      var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root_ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'add'); return j; }); })
        .then(function () {
          var E = window.RorilioOffers;
          if (!E) { location.href = root_ + 'cart'; return; }
          return Promise.resolve(E.reconcile(true)).then(function (st) { if (!(st && E.open && E.open(st))) { if (!document.querySelector('cart-drawer.active, cart-drawer[open], .drawer.active')) location.href = root_ + 'cart'; } });
        })
        .catch(function (e) { err.textContent = C.err; err.hidden = false; console.warn('[easysleep]', e); })
        .then(function () { atc.removeAttribute('aria-busy'); });
    }
    atc.addEventListener('click', add);

    /* guía de tamaños */
    var modal = $('[data-es-size]', root);
    function closeM() { modal.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    $('[data-es-size-open]', root).addEventListener('click', function () { modal.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; });
    $('[data-es-size-close]', root).addEventListener('click', closeM);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeM(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeM(); });

    /* barra fija */
    var st = $('[data-es-sticky]', root), sv = $('[data-s-variant]', st);
    function stickySync(p, now, was) {
      $('[data-s-now]', st).textContent = money(now, C.money);
      $('[data-s-was]', st).textContent = money(was, C.money);
    }
    sv.addEventListener('change', function () {
      var v = byId(sv.value), p = selected(), r = $('[data-row]', p);
      if (!v || !r) return;
      $('[data-color]', r).value = v.c; $('[data-size]', r).value = v.s; sync(p); showMediaOf(v);
    });
    $('[data-s-atc]', st).addEventListener('click', add);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var e = en[0]; st.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(atc);
    }
    packs.forEach(sync);
    pick(selected());
  }

  /* carrusel (60 noches) */
  function initCar(root) {
    var c = $('.es-car', root); if (!c) return;
    var step = function () { var f = c.firstElementChild; return f ? f.getBoundingClientRect().width + 24 : c.clientWidth; };
    var p = $('[data-car-prev]', root), n = $('[data-car-next]', root);
    if (p) p.addEventListener('click', function () { c.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { c.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  /* reseñas : orden y zoom de fotos */
  function initRv(root) {
    var list = $('.es-rv__list', root), sort = $('.es-rv__sort', root);
    if (list && sort) {
      var items = $all('.es-rv__it', list);
      sort.addEventListener('change', function () {
        var k = sort.value, arr = items.slice();
        if (k === 'photos') arr.sort(function (a, b) { return (b.dataset.ph | 0) - (a.dataset.ph | 0) || (a.dataset.i - b.dataset.i); });
        else if (k === 'recent') arr.sort(function (a, b) { return (a.dataset.age - b.dataset.age) || (a.dataset.i - b.dataset.i); });
        else if (k === 'high') arr.sort(function (a, b) { return (b.dataset.r - a.dataset.r) || (a.dataset.i - b.dataset.i); });
        else if (k === 'low') arr.sort(function (a, b) { return (a.dataset.r - b.dataset.r) || (a.dataset.i - b.dataset.i); });
        arr.forEach(function (x) { list.appendChild(x); });
      });
    }
    var z = $('.es-zoom', root);
    if (z) {
      root.addEventListener('click', function (e) {
        var im = e.target.closest('[data-zoom]');
        if (im) { $('img', z).src = im.getAttribute('data-zoom'); z.classList.add('is-open'); return; }
        if (e.target.closest('.es-zoom')) z.classList.remove('is-open');
      });
    }
  }

  function boot() {
    $all('[data-es-main]').forEach(function (r) { if (!r._es) { r._es = 1; initMain(r); } });
    $all('[data-es-car]').forEach(function (r) { if (!r._es) { r._es = 1; initCar(r); } });
    $all('[data-es-rv]').forEach(function (r) { if (!r._es) { r._es = 1; initRv(r); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
